import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';

export class DateRangeQuery {

  public static startQueryString(start: string | NgbDate, timezone: string): string {
    return typeof start === 'string' ? moment.tz(start, 'YYYY-MM-DD', timezone).toISOString()
      : moment.tz(start.year + '-' + start.month + '-' + start.day, 'YYYY-MM-DD', timezone).toISOString();
  }

  public static stopQueryString(stop: string | NgbDate, timezone: string, isCustomSingleDay: boolean): string {
    if(isCustomSingleDay) {
      return typeof stop === 'string' ? moment.tz(stop, 'YYYY-MM-DD', timezone).add(1, 'days').startOf('day').toISOString()
        : moment.tz(stop.year + '-' + stop.month + '-' + stop.day, 'YYYY-MM-DD', timezone).add(1, 'days').startOf('day').toISOString();
    } else {
      return typeof stop === 'string' ? moment.tz(stop, 'YYYY-MM-DD', timezone).add(1, 'days').endOf('day').toISOString()
        : moment.tz(stop.year + '-' + stop.month + '-' + stop.day, 'YYYY-MM-DD', timezone).add(1, 'days').startOf('day').toISOString();
    }
  }

  public static startDisplayString(start: string | NgbDate): string {
    return typeof start === 'string' ? moment(start, 'YYYY-MM-DD').format('YYYY-MM-DD')
      : moment(start.year + '-' + start.month + '-' + start.day, 'YYYY-MM-DD').format('YYYY-MM-DD');
  }

  public static stopDisplayString(stop: string | NgbDate): string {
    return typeof stop === 'string' ? moment(stop, 'YYYY-MM-DD').format('YYYY-MM-DD')
      : moment(stop.year + '-' + stop.month + '-' + stop.day, 'YYYY-MM-DD').format('YYYY-MM-DD');
  }

  public static isSingleCustomDateRange(start: string | NgbDate, stop: string | NgbDate, timezone: string): boolean {
      const momentStart = typeof start === 'string' ? moment.tz(start, 'YYYY-MM-DD', timezone)
        : moment.tz(start.year + '-' + start.month + '-' + start.day, 'YYYY-MM-DD', timezone);

    const momentStop = typeof stop === 'string' ? moment.tz(stop, 'YYYY-MM-DD', timezone)
      : moment.tz(stop.year + '-' + stop.month + '-' + stop.day, 'YYYY-MM-DD', timezone);

    return momentStart.format('L') === momentStop.format('L');
  }
}
